import { Injectable } from "@angular/core";
import { IdynamicFormItem } from "@ispm/dynamic-form/interfaces/IdynamicFormItem";
import { GroupingAndOrderingService } from "@ispm/shared/services/grouping-and-ordering.service";
import { isEmpty } from "lodash";


@Injectable()
export class WidgetCountProcessorService {

           constructor(private groupingAndOrderingService: GroupingAndOrderingService) {}


  /**
   * Process the logics of different widgets that modified the content and derive the count Information
   * @param {IdynamicFormItem} dynamicFormItem
   * @param itemValue
   * @returns {number}
   */
       processWidgetToDetermineContentShown(dynamicFormItem: IdynamicFormItem, itemValue: any): any {
         if (isEmpty(itemValue)){
           return 0;
         }
         if (dynamicFormItem.options.component === 'GroupTableComponent' || dynamicFormItem.options.component === 'ChartWidgetComponent') {
               const widgetPayload = dynamicFormItem.widgetPayload;
               const viewAll = widgetPayload.viewAll;
               let items = this.groupingAndOrderingService.getGrouppedAndOrderedDataStructureByGroupIds
               (itemValue, widgetPayload.groupBy, widgetPayload.groupOrderAttribute,
                 widgetPayload.orderBy);
               if (!viewAll) {
                 if (widgetPayload.showCount) {
                   items = items.slice(0, widgetPayload.showCount);
                 }
                 return items;
               }
               else {
                 return items;
               }

           }
           if(dynamicFormItem.options.component === 'SegmentFindingsTableComponent') {
            const widgetPayload = dynamicFormItem.widgetPayload;
             return itemValue;
           }
       }


}
